import { formComponents as fc } from "@/components/form";
import { Label } from "@/components/ui/label";
import InviteForm from "@/features/invite/components/InviteForm";
import { useClinicianOptions } from "../../../../auth/api/cliniciansByOrganisationQuery";

export function SurgeryCliniciansFormFields({
	organisationId,
	referringClinicianFieldName = "referring_clinician_id",
	operatingClinicianFieldName = "operating_clinician_id",
}: {
	organisationId?: string;
	referringClinicianFieldName?: string;
	operatingClinicianFieldName?: string;
}) {
	const clinicianOptions = useClinicianOptions(organisationId ?? "");

	return (
		<div className="space-y-6">
			<div>
				<Label htmlFor="referring_clinician_id">Referring Clinician</Label>
				<fc.ComboBox
					autoFocus
					name={referringClinicianFieldName}
					description="The clinician who requests the surgery"
					options={clinicianOptions}
					clearable={true}
					addOption={<InviteForm />}
				/>
			</div>
			<div>
				<Label htmlFor="operating_clinician_id">Operating Clinician</Label>
				<fc.ComboBox
					name={operatingClinicianFieldName}
					description="The clinician who performs the surgery"
					options={clinicianOptions}
					clearable={true}
					addOption={<InviteForm />}
				/>
			</div>
		</div>
	);
}
